import { Course } from 'types/courses';
import { Select } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const SelectCourse = observer(() => {
  const { t } = useTranslation();
  const cs = useStores().coursesStore;

  return (
    <Select
      label={t('SelectCourse', { ns: 'organizationPage' })}
      value={cs.selectedCourseId ?? ''}
      className='select-course'
      onChange={(event) => {
        cs.selectedCourseId = event.target.value as string;
        cs.selectedCourseName = cs.coursesList.find((course: Course) => course.id === cs.selectedCourseId)?.courseName ?? '';
      }}
      selectOptions={cs.coursesList.map((course) => {
        return {
          label: course.courseName === ' ' ? t('PleaseSelectCourse', { ns: 'organizationPage' }) : course.courseName,
          value: course.id,
        };
      })}
    />
  );
});

export default SelectCourse;
